import * as localizations from './contentLocalizacion';
export const appStrings = localizations;
